/* RONCADOR: pagina de produto igual a Fashion Nova (secao rc-produto)
   - fotos que arrastam, com bolinhas e foto ampliada ao tocar;
   - tamanho e cor: escolhe a variante, mostra o que esta esgotado e
     troca a foto quando muda a cor;
   - botao poe no carrinho e abre o carrinho lateral (mesmo caminho do
     botao padrao do tema, com o aviso de "adicionado" para a Shopify);
   - coracao salva nos favoritos (neste aparelho);
   - barra fixa no topo quando o botao sai da tela;
   - folhas de baixo: tabela de medidas e troca;
   - CEP abre a calculadora de frete. */
(function () {
  function iniciar() {
    var raiz = document.querySelector('[data-rc-pdp]');
    if (!raiz || raiz.dataset.rcPronto) return;
    raiz.dataset.rcPronto = '1';

    var dadosEl = raiz.querySelector('[data-rc-pdp-produto]');
    var P = JSON.parse(dadosEl.textContent);
    var sel = {};
    var base = null;
    P.variantes.forEach(function (v) {
      if (P.escolhida && v.id === P.escolhida) base = v;
    });
    var inicial = base || P.variantes.filter(function (v) {
      return v.disponivel;
    })[0] || P.variantes[0];
    P.opcoes.forEach(function (o, i) {
      /* a cor (e outras) ja vem marcada; o tamanho so se veio no link */
      if (i !== P.iTam || base || P.opcoes.length === 1 && P.iTam < 0) sel[i] = inicial.opcoes[i];
    });
    if (P.iTam > -1) {
      var unicos = {};
      P.variantes.forEach(function (v) {
        unicos[v.opcoes[P.iTam]] = 1;
      });
      if (Object.keys(unicos).length === 1) sel[P.iTam] = inicial.opcoes[P.iTam];
    }
    if (P.iTam < 0 && P.iCor < 0) {
      P.opcoes.forEach(function (o, i) {
        sel[i] = inicial.opcoes[i];
      });
    }

    function combinam(ignorar) {
      return P.variantes.filter(function (v) {
        return P.opcoes.every(function (o, i) {
          return i === ignorar || sel[i] == null || v.opcoes[i] === sel[i];
        });
      });
    }
    function escolhida() {
      for (var i = 0; i < P.opcoes.length; i++) if (sel[i] == null) return null;
      return combinam(-1)[0] || null;
    }
    function dinheiro(c) {
      return 'R$ ' + (c / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    /* ---------- fotos ---------- */
    var fotos = raiz.querySelector('[data-rc-pdp-fotos]');
    var pontos = raiz.querySelectorAll('.rc-pdp__ponto');
    function fotoAtual() {
      if (!fotos || !fotos.children.length) return 0;
      var w = fotos.children[0].offsetWidth + 2;
      return Math.round(fotos.scrollLeft / w);
    }
    if (fotos) {
      fotos.addEventListener(
        'scroll',
        function () {
          var n = fotoAtual();
          pontos.forEach(function (p, k) {
            p.classList.toggle('is-on', k === n);
          });
        },
        { passive: true }
      );
    }
    function irParaFoto(idMidia) {
      if (!fotos || !idMidia) return;
      var alvo = fotos.querySelector('[data-rc-pdp-foto="' + idMidia + '"]');
      if (alvo) fotos.scrollTo({ left: alvo.offsetLeft, behavior: 'smooth' });
    }

    /* foto ampliada */
    var zoom = raiz.querySelector('[data-rc-pdp-zoom]');
    function travar(sim) {
      document.documentElement.classList.toggle('rc-pdp-travado', sim);
    }
    raiz.addEventListener('click', function (e) {
      var f = e.target.closest('[data-rc-pdp-foto]');
      if (f && zoom) {
        zoom.hidden = false;
        travar(true);
        var caixa = zoom.querySelector('[data-rc-pdp-zoom-fotos]');
        var n = Number(f.getAttribute('data-indice')) || 0;
        requestAnimationFrame(function () {
          caixa.scrollLeft = caixa.clientWidth * n;
          zoom.classList.add('is-aberto');
        });
        return;
      }
      if (e.target.closest('[data-rc-pdp-zoom-fecha]') && zoom) {
        zoom.classList.remove('is-aberto');
        zoom.hidden = true;
        travar(false);
      }
    });

    /* compartilhar */
    var comp = raiz.querySelector('[data-rc-pdp-compartilhar]');
    if (comp) {
      comp.addEventListener('click', function () {
        var dados = { title: P.titulo, url: location.href.split('?')[0] };
        if (navigator.share) {
          navigator.share(dados).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(dados.url);
          comp.classList.add('is-copiado');
          setTimeout(function () {
            comp.classList.remove('is-copiado');
          }, 1500);
        }
      });
    }

    /* ---------- tamanho e cor ---------- */
    var add = raiz.querySelector('.rc-pdp__add');
    var addFixo = raiz.querySelector('.rc-pdp__fixa-add');
    var erro = raiz.querySelector('[data-rc-pdp-erro]');
    var textoBotao = add ? add.textContent.trim() : 'Adicionar ao carrinho';

    function atualizar(mudouCor) {
      P.opcoes.forEach(function (o, i) {
        var possiveis = combinam(i);
        raiz.querySelectorAll('[data-rc-pdp-op="' + i + '"]').forEach(function (b) {
          var val = b.getAttribute('data-valor');
          var tem = possiveis.some(function (v) {
            return v.opcoes[i] === val && v.disponivel;
          });
          b.classList.toggle('is-on', sel[i] === val);
          b.classList.toggle('is-off', !tem);
          b.setAttribute('aria-pressed', sel[i] === val ? 'true' : 'false');
        });
      });
      var rotCor = raiz.querySelector('[data-rc-pdp-rot-cor]');
      if (rotCor && P.iCor > -1 && sel[P.iCor]) rotCor.textContent = sel[P.iCor];
      var v = escolhida();
      var ref = v || combinam(-1).filter(function (x) {
        return x.disponivel;
      })[0];
      if (mudouCor && ref) irParaFoto(ref.foto);
      if (v) {
        var u = new URL(location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', u.pathname + u.search + u.hash);
      }
      var esgotado = v && !v.disponivel;
      [add, addFixo].forEach(function (b) {
        if (!b) return;
        b.disabled = !!esgotado;
      });
      if (add) add.textContent = esgotado ? 'Esgotado' : textoBotao;
      if (erro) erro.hidden = true;
      var gTam = raiz.querySelector('[data-rc-pdp-grupo="' + P.iTam + '"]');
      if (gTam && sel[P.iTam] != null) gTam.classList.remove('is-alerta');
    }

    raiz.addEventListener('click', function (e) {
      var b = e.target.closest('[data-rc-pdp-op]');
      if (!b) return;
      var i = Number(b.getAttribute('data-rc-pdp-op'));
      sel[i] = b.getAttribute('data-valor');
      /* trocou a cor e o tamanho escolhido nao existe nela: limpa */
      if (i !== P.iTam && P.iTam > -1 && sel[P.iTam] != null) {
        var ok = combinam(-1).some(function (v) {
          return v.disponivel;
        });
        if (!ok) sel[P.iTam] = null;
      }
      atualizar(i === P.iCor);
    });

    /* ---------- carrinho ---------- */
    function pedirTamanho() {
      var g = raiz.querySelector('[data-rc-pdp-grupo="' + P.iTam + '"]');
      if (!g) return;
      g.classList.remove('is-alerta');
      void g.offsetWidth;
      g.classList.add('is-alerta');
      var y = g.getBoundingClientRect().top + window.scrollY - 140;
      if (g.getBoundingClientRect().top < 120 || g.getBoundingClientRect().bottom > window.innerHeight) {
        window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      }
    }
    function adicionar(botao) {
      var v = escolhida();
      if (!v) {
        pedirTamanho();
        return;
      }
      if (!v.disponivel) return;
      var carrinho = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var dados = new FormData();
      dados.append('id', v.id);
      dados.append('quantity', 1);
      if (carrinho && carrinho.getSectionsToRender) {
        dados.append(
          'sections',
          carrinho.getSectionsToRender().map(function (s) {
            return s.id;
          })
        );
        dados.append('sections_url', window.location.pathname);
      }
      var SE = window.StandardEvents || {};
      var adiado = null;
      if (SE.CartLinesUpdateEvent) {
        adiado = SE.CartLinesUpdateEvent.createPromise();
        botao.dispatchEvent(
          new SE.CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: v.id, quantity: 1 }],
            promise: adiado.promise,
          })
        );
      }
      botao.classList.add('is-carregando');
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: dados,
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (res) {
          botao.classList.remove('is-carregando');
          if (res.status) {
            if (erro) {
              erro.textContent = res.description || res.message || 'Não foi possível adicionar.';
              erro.hidden = false;
            }
            if (adiado) adiado.reject(new Error(res.description || res.message));
            return;
          }
          if (adiado) {
            fetch(((window.routes && window.routes.cart_url) || '/cart') + '.json', { credentials: 'same-origin' })
              .then(function (r) {
                return r.json();
              })
              .then(function (c) {
                adiado.resolve({ cart: SE.CartLinesUpdateEvent.createCartFromAjaxResponse(c) });
              })
              .catch(function (er) {
                adiado.reject(er);
              });
          }
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: v.id, cartData: res });
          }
          if (!carrinho || !carrinho.renderContents) {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
            return;
          }
          if (carrinho.setActiveElement) carrinho.setActiveElement(botao);
          carrinho.classList.remove('is-empty');
          carrinho.renderContents(res);
        })
        .catch(function (er) {
          botao.classList.remove('is-carregando');
          if (erro) {
            erro.textContent = 'Sem conexão. Tente de novo.';
            erro.hidden = false;
          }
          if (adiado) adiado.reject(er);
        });
    }
    raiz.querySelectorAll('[data-rc-pdp-add]').forEach(function (b) {
      b.addEventListener('click', function () {
        adicionar(b);
      });
    });

    /* ---------- favoritos (assets/rc-favoritos.js) ----------
       Coracao vazio: abre "SELECIONE UM TAMANHO" e salva.
       Coracao vermelho: tira dos favoritos. */
    var fav = raiz.querySelector('[data-rc-pdp-fav]');
    function marcarFav() {
      var on = !!(window.rcFav && window.rcFav.tem(raiz.dataset.handle));
      fav.classList.toggle('is-on', on);
      fav.setAttribute('aria-pressed', on ? 'true' : 'false');
      fav.setAttribute('aria-label', on ? 'Tirar dos favoritos' : 'Salvar nos favoritos');
    }
    if (fav) {
      marcarFav();
      document.addEventListener('rc:favoritos', marcarFav);
      fav.addEventListener('click', function () {
        if (!window.rcFav) return;
        if (window.rcFav.tem(raiz.dataset.handle)) {
          window.rcFav.remover(raiz.dataset.handle);
          return;
        }
        var ref = escolhida() || combinam(-1).filter(function (x) {
          return x.disponivel;
        })[0] || P.variantes[0];
        var tams = [];
        if (P.iTam > -1) {
          var vistos = {};
          P.variantes.forEach(function (v) {
            var t = v.opcoes[P.iTam];
            if (!vistos[t]) {
              vistos[t] = { valor: t, disponivel: false };
              tams.push(vistos[t]);
            }
            if (v.disponivel) vistos[t].disponivel = true;
          });
        }
        var img = raiz.querySelector('.rc-pdp__foto img');
        window.rcFav.abrirSalvar({
          handle: raiz.dataset.handle,
          titulo: P.titulo,
          url: location.pathname,
          foto: img ? img.currentSrc || img.src : '',
          preco: ref.preco,
          de: ref.de,
          tamanhos: tams,
          tamanhoAtual: P.iTam > -1 ? sel[P.iTam] : null
        });
      });
    }

    /* ---------- barra fixa ---------- */
    var fixa = raiz.querySelector('[data-rc-pdp-fixa]');
    var compra = raiz.querySelector('[data-rc-pdp-compra]');
    var precoFixo = raiz.querySelector('[data-rc-pdp-fixa-preco]');
    var precoPix = raiz.querySelector('.rc-preco__pix');
    var precoDe = raiz.querySelector('.rc-preco__de');
    if (precoFixo) {
      precoFixo.innerHTML =
        '<b>' + (precoPix ? precoPix.textContent.trim() : '') + '</b>' + (precoDe ? ' <s>' + precoDe.textContent.trim() + '</s>' : '');
    }
    function topoCabecalho() {
      var sh = document.querySelector('.section-header');
      if (!sh) return 0;
      return Math.max(0, Math.round(sh.getBoundingClientRect().bottom));
    }
    var ate = 0;
    var rodando = false;
    function quadro() {
      if (!document.body.contains(raiz)) {
        rodando = false;
        return;
      }
      var mostra = compra && compra.getBoundingClientRect().bottom < 0;
      fixa.classList.toggle('is-on', !!mostra);
      fixa.setAttribute('aria-hidden', mostra ? 'false' : 'true');
      if (addFixo) addFixo.tabIndex = mostra ? 0 : -1;
      fixa.style.top = topoCabecalho() + 'px';
      if (performance.now() < ate) {
        requestAnimationFrame(quadro);
      } else {
        rodando = false;
      }
    }
    function acordar() {
      ate = performance.now() + 600;
      if (!rodando) {
        rodando = true;
        requestAnimationFrame(quadro);
      }
    }
    if (fixa) {
      window.addEventListener('scroll', acordar, { passive: true });
      acordar();
    }

    /* ---------- folhas de baixo ---------- */
    var folha = raiz.querySelector('[data-rc-pdp-folha-caixa]');
    function abrirFolha(titulo, html) {
      if (!folha) return;
      folha.querySelector('[data-rc-pdp-folha-titulo]').textContent = titulo;
      var corpo = folha.querySelector('[data-rc-pdp-folha-corpo]');
      if (typeof html === 'string') {
        corpo.innerHTML = html;
      } else {
        corpo.innerHTML = '';
        corpo.appendChild(html);
      }
      folha.hidden = false;
      travar(true);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          folha.classList.add('is-aberta');
        });
      });
    }
    function fecharFolha() {
      if (!folha || folha.hidden) return;
      folha.classList.remove('is-aberta');
      travar(false);
      setTimeout(function () {
        folha.hidden = true;
      }, 380);
    }
    raiz.addEventListener('click', function (e) {
      if (e.target.closest('[data-rc-pdp-folha-fecha]')) {
        fecharFolha();
        return;
      }
      var f = e.target.closest('[data-rc-pdp-folha]');
      if (f) {
        var modelo = raiz.querySelector('[data-rc-pdp-modelo="' + f.getAttribute('data-rc-pdp-folha') + '"]');
        if (modelo) abrirFolha(f.getAttribute('data-titulo') || f.textContent.trim(), modelo.content.cloneNode(true));
        return;
      }
      var cep = e.target.closest('[data-rc-pdp-cep]');
      if (cep) {
        var caixa = raiz.querySelector('[data-rc-pdp-frete]');
        var abrir = caixa.hidden;
        caixa.hidden = !abrir;
        cep.setAttribute('aria-expanded', abrir ? 'true' : 'false');
        if (abrir) {
          var inp = caixa.querySelector('input');
          if (inp) inp.focus({ preventScroll: true });
        }
        return;
      }
      var ir = e.target.closest('[data-rc-pdp-ir-avaliacoes]');
      if (ir) {
        var alvo = document.querySelector('.rc-rev') || document.getElementById('rc-avaliacoes');
        if (alvo) {
          e.preventDefault();
          window.scrollTo({ top: alvo.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' });
        }
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      fecharFolha();
      if (zoom && !zoom.hidden) {
        zoom.hidden = true;
        travar(false);
      }
    });

    atualizar(false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
  document.addEventListener('rc:pagina-trocada', iniciar);
})();
